import { Component } from '@angular/core';
import { ChartDataset } from 'chart.js';
import { GRAPH_PANEL_IMPORTS, GraphPanelComponent } from 'src/app/panels/components/graph-panel/graph-panel.component';
import { PanelComponent } from 'src/app/panels/components/panel.component';
import { DisplayUnit } from 'src/app/panels/models/display-unit';
import { GenerateGraphDataset, GraphType, IGraphConfig, IGraphMappedDataset } from 'src/app/panels/models/graph';
import { PanelType } from 'src/app/panels/models/panel-type';
import { Color } from 'src/app/shared/services/color/colors';

@PanelComponent.register
@Component({
  templateUrl: '../../../../panels/components/graph-panel/graph-panel.component.html',
  styleUrl: '../../../../panels/components/graph-panel/graph-panel.component.scss',
  selector: 'app-outdoor-climate-graph-panel',
  imports: GRAPH_PANEL_IMPORTS,
})
export class OutsideClimateGraphPanelComponent extends GraphPanelComponent {
  public static override readonly type = PanelType.OutsideClimateGraph;
  protected override unit = DisplayUnit.DegreeCelsius;

  protected override config: IGraphConfig = {
    sortOrder: [GraphType.ClimateOutsideAirTemperature, GraphType.ClimateOutsideHumidity],
    legendSortOrder: [GraphType.ClimateOutsideAirTemperature, GraphType.ClimateOutsideHumidity],
    getGraphTypeDataset: this.getGraphTypeDataset,
  };

  private getGraphTypeDataset(
    generateDataset: GenerateGraphDataset,
    dataset: IGraphMappedDataset,
    startTimestamps: string[],
    endTimestamps: string[],
  ): ChartDataset {
    switch (dataset.type) {
      case GraphType.ClimateOutsideAirTemperature:
        return generateDataset(
          dataset,
          startTimestamps,
          endTimestamps,
          'Luchttemperatuur',
          Color.Blue,
          DisplayUnit.DegreeCelsius,
          'line',
        );
      case GraphType.ClimateOutsideHumidity:
        return generateDataset(
          dataset,
          startTimestamps,
          endTimestamps,
          `Luchtvochtigheid (${DisplayUnit.Percentage})`,
          Color.DarkBlue,
          DisplayUnit.Percentage,
          'line',
        );
      default:
        throw new Error(`No dataset specified for GraphType '${dataset.type}'`);
    }
  }
}
